import { createModule, mutation } from 'vuex-class-component';
import { CreateContractModel } from '@/models/contract.model';
import { ContractPartnerModel } from '@/models/contractPartnerModel';
import { ContractClausesModel } from '@/models/contractClausesModel';
import { DDCalendarDate } from '@/models/common';
import { ClauseForRequest } from '@/models/clause.model';

const VuexModule = createModule({
  namespaced: 'Contract',
  strict: false,
  target: 'nuxt',
});

export default class ContractStore extends VuexModule {
  private Contract: CreateContractModel = {
    partners: [] as ContractPartnerModel[],
  } as CreateContractModel;
  specialty = 'JavaScript';

  private clausesText: ContractClausesModel[] = [];

  @mutation setContractName(name: string) {
    this.Contract.contractName = name;
  }

  @mutation setContractPreliminary(preliminary: string | null) {
    this.Contract.preliminaryLabel = preliminary;
  }

  @mutation setContractPreliminaryText(preliminaryText: string | null) {
    this.Contract.preliminaryText = preliminaryText;
  }

  @mutation setContractIntroduction(introduction: string | null) {
    this.Contract.introductionLabel = introduction;
  }

  @mutation setContractIntroductionText(introductionText: string | null) {
    this.Contract.introductionText = introductionText;
  }

  @mutation setContractStatus(statusId: number) {
    this.Contract.statusId = statusId;
  }

  @mutation setContractTemplate(TemplateId: number) {
    this.Contract.contractTemplateId = TemplateId;
    this.Contract.id = TemplateId;
  }

  @mutation setContractClausesText(clauses: ContractClausesModel[]) {
    this.clausesText = clauses;
  }

  @mutation setContractClauses(clauses: ClauseForRequest[]) {
    this.Contract.clauses = clauses;
  }

  @mutation setContractFirstPartner(firstPartner: ContractPartnerModel) {
    this.Contract.firstPartner = firstPartner;
  }

  @mutation setContractSecondPartner(secondPartner: ContractPartnerModel) {
    this.Contract.secondPartner = secondPartner;
  }

  @mutation setContractPartner(partner: ContractPartnerModel) {
    const part = this.Contract?.partners?.find((x) => x.partnerTarafTypeId === partner.partnerTarafTypeId);
    if (part) {
      this.Contract.partners = this.Contract?.partners?.map((x) => ((x.partnerTarafTypeId === partner.partnerTarafTypeId) ? partner : x));
    } else {
      this.Contract.partners.push(partner);
    }
  }

  @mutation removeContractPartners(partners: ContractPartnerModel[]) {
    partners.forEach((partner) => {
      this.Contract.partners = this.Contract.partners.filter((x) => x.partnerTarafTypeId !== partner.partnerTarafTypeId);
    });
  }

  @mutation replacePartner(partner: ContractPartnerModel) {
    // get partner index
    const oldPartner = this.Contract.partners.find((x) => x.partnerTarafTypeId === partner.partnerTarafTypeId);

    if (oldPartner) {
      const index = this.Contract.partners.indexOf(oldPartner);
      this.Contract.partners[index] = partner;
    }
  }

  @mutation setContractDate(range: { startDate: DDCalendarDate, endDate: DDCalendarDate }) {
    this.Contract.startDate = range.startDate;
    this.Contract.endDate = range.endDate;
  }

  @mutation setTemplateId(templateId: number) {
    this.Contract.contractTemplateId = templateId;
  }

  @mutation setHasLawyer(hasLawyer: boolean) {
    this.Contract.hasLawyer = hasLawyer;
  }

  @mutation setIsEditMobileNumber(partner: ContractPartnerModel) {
    const storePartner = this.Contract.partners.find((x) => x.partnerTarafTypeId === partner.partnerTarafTypeId);

    if (storePartner) {
      storePartner.isEditMobileNumber = partner.isEditMobileNumber;
    }
  }

  @mutation clearContract() {
    this.Contract = {
      partners: [] as ContractPartnerModel[],
    } as CreateContractModel;
  }

  get getContract() {
    return this.Contract;
  }

  get getContractPartners() {
    return this.Contract.partners;
  }

  get getTemplateId() {
    return this.Contract.contractTemplateId;
  }

  get getHasLawyer() {
    return this.Contract.hasLawyer;
  }

  get getClausesText() {
    return this.clausesText;
  }
}
